<template>
  <div id="app" :class="host">
    <div>
      <div id="title-bar" v-if="authenticated && ['product', 'terms-conditions', 'privacy-policy', 'contact'].indexOf($route.name) < 0" style="z-index:1000">
        <div id="brand"><span><img src="/static/img/freight-intelligence-logo.png" alt="Logo"></span></div>
        <user-area :user="user" :hasConventional="userInfo.has_conventional"></user-area>
      </div>
      <spinner v-show="pageLoading"></spinner>
       <div v-show="!pageLoading" id="body" :class="$route.name" class="tile is-child is-margin-less columns is-gapless">
          <div id="app-content">
              <notifications group="global" position="bottom left" style="z-index:9999"/>
              <router-view
                @loaded="pageLoading=false"
                @loading="pageLoading=true"
                :authenticated="authenticated"
                :userInfo="userInfo"
                :_userInfo="userInfo"
              />
              <div id="footer" class="level" v-if="authenticated">
                <router-link to="/">
                  <p class="is-left">Copyright © {{ year }} Freight Intelligence | {{ version }}</p>
                </router-link>
              </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

import Spinner from '@/components/Spinner'
import Sidebar from '@/components/Sidebar'
import UserArea from '@/components/UserArea'

export default {
  name: 'app',
  components: {Spinner, Sidebar, UserArea},
  created () {
    this.host = window.location.hostname
    this.host = this.host.substring(0, this.host.indexOf('.'))
  },
  mounted () {
    if (this.authenticated) {
      this.getUserInfo().then(response => {})
    }
    window.addEventListener('scroll', this.scroll)
    this.year += new Date().getFullYear()
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'es')
    }
    this.$i18n.locale = localStorage.getItem('lang')
  },
  data () {
    return {
      host: '',
      pageLoading: false,
      top: 0,
      left: 0,
      year: '2017 - ',
      version: Vue.config.app.VERSION
    }
  },
  watch: {
    notification (message) { if (!message) { return }; this.$notify(message) }
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
      user: state => state.auth.user,
      userInfo: state => state.user.user,
      notification: state => state.notification
    })
  },
  methods: {
    ...mapActions({
      getUserInfo: 'user/read'
    }),
    scroll () {
      if (window.innerWidth <= 620) {
        this.top = window.scrollY + 'px'
        this.left = window.scrollX + 'px'
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue